module.exports = "/_next/static/images/cnet-wreath-18e8ad26f38aa7320846b72eea7e78d7.svg";